import React from "react";
import {makeStyles, TableCell, Tooltip} from "@material-ui/core";
import PropTypes from "prop-types";
import Tr from 'translations/Translations'
import {CheckBox as CheckBoxIcon, CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon, IndeterminateCheckBox as IndeterminateCheckBoxIcon} from '@material-ui/icons';
import IconButton from "components/button/IconButton";
import clsx from "clsx";
import Filter1Icon from '@material-ui/icons/Filter1';
import formatAmountNumber from "libs/formatAmountNumber";

const useStyles = makeStyles(theme => ({
    italic: {
        fontStyle: 'italic',
        userSelect: 'none'
    },
    evenRow: {
        backgroundColor: theme.palette.background.default
    },
    lastRow: {
        borderBottom: `solid 2px ${theme.palette.primary.main}`
    },
    statusSelect: {
        width: 170,
        "& .MuiSelect-selectMenu": {
            whiteSpace: "normal"
        }
    },
    iconColumn: {
        padding: '0 !important'
    },
    columnChecked: {
        backgroundColor: theme.palette.secondary.light
    },
    unavailable: {
        color: theme.palette.text.secondary
    },
    maxPoints: {
        fontWeight: theme.typography.fontWeightBold,
        textDecoration: 'underline'
    },
    iconMax: {
        fontSize: 'medium'
    }
}));


function OfferChoiceContractorRowPart(
    {
        editable,
        chosen,
        chooseSupplierCountReached,
        offerChoiceContractor,
        offerChoiceRow,
        chooseSupplier,
        maxPartScore
    }) {

    const classes = useStyles();


    const getTooltip = () => {
        if (editable && !chosen) {
            if (offerChoiceContractor.available) {
                if (chooseSupplierCountReached)
                    return Tr('choose_supplier_max_tooltip', {max: offerChoiceRow.maxOfferChoiceCount})
            } else {
                return offerChoiceContractor.unavailableReason ? offerChoiceContractor.unavailableReason : Tr('choose_supplier_unavilable');
            }
        }
        return null;
    }
    const maxScore = maxPartScore === offerChoiceContractor.offerScore;
    const className =clsx({
        [classes.columnChecked]: chosen,
        [classes.unavailable]: !offerChoiceContractor.available,
        [classes.maxPoints]: offerChoiceContractor.available && maxScore});
    return (<>
            <TableCell className={className}>{maxScore &&<Tooltip title={Tr('offer_with_max_points')}><Filter1Icon className={classes.iconMax} /></Tooltip>}
                {offerChoiceContractor.consorciumOffer ? Tr('consorcium_with_name', {name: offerChoiceContractor.name}) : offerChoiceContractor.name}</TableCell>
            <TableCell className={className}>{offerChoiceContractor.offerValue}</TableCell>
            <TableCell className={className}>{formatAmountNumber(offerChoiceContractor.offerScore)}</TableCell>
            <TableCell className={clsx(classes.iconColumn)}>
                <IconButton
                    className={clsx({[classes.unavailable]: !offerChoiceContractor.available})}
                    disabled={!offerChoiceContractor.available || !editable || (!chosen && chooseSupplierCountReached)}
                    tooltip={getTooltip()}
                    onClick={() => chooseSupplier(offerChoiceContractor)}
                    Icon={offerChoiceContractor.available ? (chosen ? CheckBoxIcon : CheckBoxOutlineBlankIcon) : IndeterminateCheckBoxIcon}
                    color={ offerChoiceContractor.available ? 'primary' : undefined}
                />
            </TableCell>
        </>
    )
}

OfferChoiceContractorRowPart.propTypes = {
    editable: PropTypes.bool.isRequired,
    chosen: PropTypes.bool.isRequired,
    chooseSupplierCountReached: PropTypes.bool.isRequired,
    offerChoiceContractor: PropTypes.object.isRequired,
    offerChoiceRow: PropTypes.object.isRequired,
    chooseSupplier: PropTypes.func.isRequired,
    maxPartScore: PropTypes.number.isRequired
}

export default OfferChoiceContractorRowPart;

